import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Account.UploadProfilePhoto.IRequest;
type Response = Api.Core.Account.UploadProfilePhoto.IResponse;
type Headers = Api.Core.Account.UploadProfilePhoto.IHeaders;
const apiAccountUploadProfilePhotoPath = '/api/Account/UploadProfilePhoto';
export default async function accountUploadProfilePhotoApi(request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: apiAccountUploadProfilePhotoPath,
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
